export const environment = {
  production: false,
  useApi: false,
  baseUri: 'https://api.vibes2-dev.apps4.icldig.icl-group.com/',
  dataApiEndpoint: 'getPaperChart',
  stocksAPIUrl: 'globes-api/getAllPapers',
  histogramStockAPIUrl: `globes-api/getPaperChart?paperid={{paperId}}`,
  adalConfig: {
    clientId: 'd1a29b6b-e33e-4353-be5a-bdc284189b25',//'4331a39e-68e4-4ab8-b58b-66e0e9ad4168',
    issuer: 'https://login.microsoftonline.com/802762d2-02c4-4677-98ba-54060a234204/v2.0',
    strictDiscoveryDocumentValidation: false,
    responseType: 'id_token token',
    scope: 'd1a29b6b-e33e-4353-be5a-bdc284189b25/.default'//'4331a39e-68e4-4ab8-b58b-66e0e9ad4168/.default',
  },
  firebaseConfig: {
    apiKey: "AIzaSyB5dYwDQ9N6GidLpEF2TJoZshNkjbyV_1w",
    authDomain: "learning-ac695.firebaseapp.com",
    projectId: "learning-ac695",
    storageBucket: "learning-ac695.appspot.com",
    messagingSenderId: "878393829090",
    appId: "1:878393829090:web:05fc60d1641a4639bae0bb",
    measurementId: "G-HHFKTNB4MP"
  },
  version: '2.1.1',
};
